import AppleIcon from '@mui/icons-material/Apple'
import GavelIcon from '@mui/icons-material/Gavel'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip'
import ShopIcon from '@mui/icons-material/Shop'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import { Container, useMediaQuery, useTheme } from '@mui/material'
import Fab from '@mui/material/Fab'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'
import { GameDataModel } from './GameDataModel'
import { GameThumbnail } from './GameThumbnail'
import YouTubeIcon from '@mui/icons-material/YouTube'
type Props = {
  game: GameDataModel
}

export function GameInfoView({ game }: Props) {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'end',
        alignItems: 'end',
        height: '100%',
        p: isLargeScreen ? 8 : 4,
        color: 'white',
      }}
      disableGutters={true}
    >
      <Box sx={{ flexGrow: 1 }} />
      <GameThumbnail
        thumbnailImagePath={game.thumbnailImagePath}
        thumbnailImageSize={isLargeScreen ? 128 : 64}
      />
      <Typography variant={isLargeScreen ? 'h2' : 'h3'} gutterBottom>
        {game.title}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <b>{game.tags.join(' · ')}</b>
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        {game.description}
      </Typography>
      <Box>
        {game.actions.map((action, index) => (
          <Fab
            key={index}
            variant={
              isLargeScreen && action.label != null && action.label != ''
                ? 'extended'
                : 'circular'
            }
            size="large"
            color="primary"
            sx={{
              backgroundColor: action.buttonColor,
              color: action.contentColor,
              ml: 1,
              mb: 1,
            }}
            onClick={() => window.open(action.link, '_blank')}
          >
            {action.icon != null && action.icon != '' && (
              <GameActionIcon
                actionIcon={action.icon}
                sx={{
                  mr:
                    isLargeScreen && action.label != null && action.label != ''
                      ? 1
                      : 0,
                }}
              />
            )}
            {isLargeScreen && action.label}
          </Fab>
        ))}
      </Box>
    </Container>
  )
}

export function GameActionIcon({
  actionIcon,
  sx,
}: {
  actionIcon: string
  sx: any
}) {
  switch (actionIcon) {
    case 'terms_of_service':
      return <GavelIcon sx={sx} />
    case 'privacy_policy':
      return <PrivacyTipIcon sx={sx} />
    case 'apple_app_store':
      return <AppleIcon sx={sx} />
    case 'google_play':
      return <ShopIcon sx={sx} />
    case 'itch':
      return <SportsEsportsIcon sx={sx} />
    case 'youtube':
      return <YouTubeIcon sx={sx} />
    default:
      return <></>
  }
}
